import React, { useState, useEffect } from 'react';
import { Avatar, IconSpinner, LayoutSingleColumn, NamedLink, Page } from '../../../components';
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';
import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import FooterContainer from '../../FooterContainer/FooterContainer';
import css from './BlogAricle.module.css';
import articleCover from '../../../assets/article-cover.png';
import prifileIcon from '../../../assets/Testimonial-Image.png';
import IconCard from '../../../components/SavedCardDetails/IconCard/IconCard';
import BlogCard from '../BlogCard/BlogCard';
import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useIntl } from '../../../util/reactIntl';
import { useConfiguration } from '../../../context/configurationContext';
import { getListingsById, getMarketplaceEntities } from '../../../ducks/marketplaceData.duck';
import { getOwnListingsById } from '../BlogMainPage.duck';
import { createSlug } from '../../../util/urlHelpers';
import { isCurrentUserAdmin } from '../../../util/helpersFunction';
import { BLOGDETAILS } from '../../../util/constants';
import { isScrollingDisabled } from '../../../ducks/ui.duck';
import { ensureListing } from '../../../util/data';
import { types as sdkTypes } from '../../../util/sdkLoader';
const { UUID } = sdkTypes;
const BlogAricleComponent = props => {
    const [copyText, setCopyText] = useState(false);
    const history = useHistory();
    const intl = useIntl();
    const config = useConfiguration();
    const
        { params,
            listing,
            loading,
            listings,
            scrollingDisabled,
            getListing,
            params: rawParams,
        } = props;
    useEffect(() => {
        const onLanguageChange = () => {
            history.push('/blog');
        };
        if (typeof window !== 'undefined') {
            window.addEventListener('languageChange', onLanguageChange);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('languageChange', onLanguageChange);
            }
        };
    }, [history]);
    // Track client hydration to avoid SSR/CSR markup differences
    const [isHydrated, setIsHydrated] = useState(false);
    useEffect(() => {
        setIsHydrated(true);
    }, []);
    const listingId = new UUID(rawParams.id);
    const currentListing = ensureListing(getListing(listingId));
    const { title = '', description, publicData,createdAt } = currentListing?.attributes || {};
    const { content,updatedAt } = publicData || {};
    const dateISO = createdAt ? new Date(createdAt).toISOString().slice(0, 10) : '';
    // Helper: format to DDMMYYYY from various inputs (ISO, digits, Date)
    const toDDMMYYYY = input => {
        if (!input) return '';
        const pad = n => String(n).padStart(2, '0');
        // If Date instance
        if (input instanceof Date && !isNaN(input)) {
            const d = input.getDate();
            const m = input.getMonth() + 1;
            const y = input.getFullYear();
            return `${pad(d)}-${pad(m)}-${y}`;
        }
        // Try parse string
        if (typeof input === 'string') {
            // Try native Date parse for ISO-like
            const parsed = new Date(input);
            if (!isNaN(parsed)) return toDDMMYYYY(parsed);
            // Fallback: extract digits (e.g., YYYYMMDD)
            const digits = input.replace(/\D/g, '');
            if (digits.length >= 8) {
                const y = digits.slice(0, 4);
                const m = digits.slice(4, 6);
                const d = digits.slice(6, 8);
                return `${d}-${m}-${y}`;
            }
            return '';
        }
        // If timestamp number
        if (typeof input === 'number') {
            const parsed = new Date(input);
            if (!isNaN(parsed)) return toDDMMYYYY(parsed);
        }
        return '';
    };
    // Prefer updatedAt (from publicData), else createdAt, else ISO of createdAt
    const showDate = toDDMMYYYY(updatedAt) || toDDMMYYYY(createdAt) || toDDMMYYYY(dateISO);
    const { displayName } = currentListing?.author?.attributes?.profile || {}
    const id = currentListing?.id?.uuid || null;

    // Normalize possible full-width brackets coming from the editor (e.g. ＜p＞ → <p>)
    const normalizedContent = (content || '')
        .replace(/＜/g, '<')
        .replace(/＞/g, '>');

    // Split content roughly in half on paragraph boundaries so we can show
    // the first half before the highlight block and the second half after it.
    const paragraphs = normalizedContent
        ? normalizedContent.split(/(?<=<\/p>)/i)
        : [];
    const midIndex = paragraphs.length > 1 ? Math.ceil(paragraphs.length / 2) : paragraphs.length;
    const firstHalfHtml = paragraphs.slice(0, midIndex).join('');
    const secondHalfHtml = paragraphs.slice(midIndex).join('');
    const firstImage = currentListing?.images && currentListing.images.length > 0
        ? currentListing.images[0]
        : null;
    const imageVariants = firstImage?.attributes?.variants || {};
    const localeLang = (intl?.locale || 'en').toLowerCase().startsWith('ar') ? 'ar' : 'en';
    const currentPref = currentListing?.attributes?.publicData?.blogTypePreference;
    const targetLang = currentPref || localeLang;
    const relatedListings = (listings || [])
        .filter(l => l?.id?.uuid !== currentListing?.id?.uuid)
        .filter(l => (l?.attributes?.publicData?.blogTypePreference || localeLang) === targetLang)
        .slice(0, 3);
    const variantPrefix = config?.layout?.listingImage?.variantPrefix || 'listing-card';
    const preferredVariantOrder = [
        `${variantPrefix}-6x`,
        `${variantPrefix}-4x`,
        `${variantPrefix}-2x`,
        `${variantPrefix}`,
        'scaled-xlarge',
        'scaled-large',
        'scaled-medium',
    ];

    const originalUrl = firstImage?.attributes?.url || null;
    let articleImageUrl =
        preferredVariantOrder.map(k => imageVariants[k]?.url).find(Boolean) ||
        imageVariants?.default?.url ||
        originalUrl ||
        null;

    const slug = createSlug(title);
    const isAdmin = isCurrentUserAdmin(props?.currentUser);
    // Use a deterministic URL for SSR/CSR parity to avoid hydration mismatches
    const origin = (process.env.REACT_APP_MARKETPLACE_ROOT_URL || '');
    const listingUrl = `${origin}/blog/${slug || ''}/${currentListing?.id?.uuid || ''}`;
    const handleCopy = () => {
        navigator.clipboard.writeText(listingUrl).then(() => {
            setCopyText(true);
        });
    };
    return (
        <Page scrollingDisabled={scrollingDisabled}>
            <LayoutSingleColumn
                mainColumnClassName={css.layoutWrapperMain}
                topbar={<TopbarContainer />}
                footer={<FooterContainer />}
            >
                {(loading || !currentListing) ? 
                <div className={css.spinnerWrapper}>
                    <div className={css.loader} />
                </div> : <>
                    <div className={css.articleWrapper}>
                        <div className={css.editBlogLink}>
                            {isHydrated && isAdmin && id ? (
                                <NamedLink
                                    className={css.manageLink}
                                    name="EditListingPage"
                                    params={{ id, slug, type: 'edit', tab: BLOGDETAILS }}
                                >
                                    <IconCard type="edit" />
                                    <FormattedMessage id="ManageListingCard.editListing" />
                                </NamedLink>
                            ) : null}
                        </div>
                        <div className={css.articleHeading}>
                            {currentListing?.attributes?.title}
                        </div>
                            {articleImageUrl ? <div className={css.articleImage}>
                                <img
                                    src={articleImageUrl}
                                    alt={intl.formatMessage({ id: 'BlogArticle.coverAlt', defaultMessage: 'Article cover' })}
                                    loading='lazy'
                                />
                            </div> : 
                            <span className={css.spinnerWrapper}>
                                <IconSpinner className={css.spinner} />
                            </span>
                            }
                        <div className={css.articleBaseDetail}>
                            <div className={css.articleDetail}>
                                <div className={css.articleProfile}>
                                    {/* <img src={prifileIcon} alt="article-profile" /> */}

                                    <Avatar user={currentListing?.author} className={css.avatar}  />
                                    <span className={css.profileName}>{displayName}</span>
                                </div>
                                <div className={css.articleDate}>
                                    <FormattedMessage id="BlogArticle.lastUpdatedOn" defaultMessage="Last updated on {date}" values={{ date: showDate }} />
                                </div>
                            </div>
                            <div className={css.articleBody}>
                                <div className={css.boldTitleText}>
                                    {description} </div>
                                <br />
                                <div
                                    className={css.descriptionText}
                                    dangerouslySetInnerHTML={{ __html: firstHalfHtml || normalizedContent }}
                                >
                                    {/* Every new phrase opens a window into meaningful stories, beautiful expressions, and traditions that have shaped millions of people across the world.
                                    <br /><br />
                                    Whether you're learning for personal growth, travel, heritage, or career opportunities, Arabic offers a unique sense of joy and discovery. Small daily lessons can transform into big improvements over time, helping you connect with native speakers, understand authentic content, and appreciate the beauty of one of the world’s oldest languages.
                                    <br /><br />
                                    This article explores why learning Arabic is so much more than an academic task. You’ll discover how the language deepens cultural understanding, enhances cognitive skills, brings new confidence, and strengthens your connection with a global community. From the rhythm of its sounds to the depth of its expressions, Arabic has a charm that makes every learner feel inspired.
                                    <br /><br />
                                    Join us as we dive deeper into the world of Arabic — how it enriches your life, expands your worldview, and reminds you that every new word is a small step toward something extraordinary. Whether you're just beginning or continuing your learning journey, this blog will help you find joy in every moment of progress. */}
                                </div>
                                <div className={css.mainCoverHighlight}>
                                    <FormattedMessage
                                        id="BlogArticle.highlight"
                                        defaultMessage="{yellow1} you learn brings new {yellow2}"
                                        values={{
                                            yellow1: chunks => <span className={css.yellowText}>{chunks}</span>,
                                            yellow2: chunks => <span className={css.yellowText}>{chunks}</span>,
                                        }}
                                    />
                                </div>
                                <div
                                    className={css.descriptionText}
                                    dangerouslySetInnerHTML={{ __html: secondHalfHtml }}
                                >
                                </div>
                                {/* <hr className={css.dividerLine} /> */}
                                {/* <div className={css.headingPoint}>
                                    1 The Joy of Learning Arabic: More Than Just Words
                                </div>
                                <br /> */}
                                {/* <div className={css.descriptionText}>
                                    Beyond personal growth, learning Arabic opens doors to new opportunities. It helps you communicate during travel, build relationships in multicultural communities, and stand out in your professional field.
                                    <br /><br />
                                    From business and education to media and global communication, Arabic is one of the most influential languages in the world today. Being able to speak it gives you access to new spaces, new people, and new experiences.
                                    <br /><br />
                                    This article takes you through the joy, challenges, and rewards of learning Arabic. You’ll explore how the language shapes identity, strengthens memory, improves creativity, and builds cross-cultural understanding.
                                    <br /><br />
                                    You’ll also discover practical tips, inspiring insights, and real-life examples that show why Arabic is worth learning — no matter your age, background, or learning style.
                                    <br /><br />
                                    By the end of the article, you’ll see that learning Arabic is not just an academic skill… It’s a life-enriching journey that brings meaning, connection, and joy at every step.
                                </div> */}
                                <hr className={css.dividerLine} />
                                <div className={css.shareArticle}>
                                    <span className={css.shareArticleHeading}>
                                        <FormattedMessage id="BlogArticle.shareThis" />
                                    </span>
                                    <FacebookShareButton url={listingUrl} quote={title} className={css.socialLinks}>
                                        <IconCard type="fb" />
                                        <FormattedMessage id="BlogArticle.share.facebook" />
                                    </FacebookShareButton>

                                    <WhatsappShareButton
                                        url={listingUrl}
                                        title={title}
                                        className={css.socialLinks}>
                                        <IconCard type="whatsapp" />
                                        <FormattedMessage id="BlogArticle.share.whatsapp" />
                                    </WhatsappShareButton>

                                    <LinkedinShareButton
                                        url={listingUrl}
                                        title={title}
                                        className={css.socialLinks}>
                                        <IconCard type="linkin" />
                                        <FormattedMessage id="BlogArticle.share.linkedin" />
                                    </LinkedinShareButton>

                                    <TwitterShareButton
                                        url={listingUrl}
                                        title={title}
                                        className={css.socialLinks}>
                                        <IconCard type="twitter" />
                                        <FormattedMessage id="BlogArticle.share.twitter" />
                                    </TwitterShareButton>

                                    <button
                                        type="button"
                                        onClick={handleCopy}
                                        className={css.socialLinks}
                                    >
                                        <IconCard type="copy" />
                                        {/* <IconCard type="copy" /> */}
                                        {
                                            <span className={css.copiedText}>
                                                {copyText ? (
                                                    <FormattedMessage id="BlogArticle.linkCopied" />
                                                ) : (
                                                    <FormattedMessage id="BlogArticle.copyLink" />
                                                )}
                                            </span>
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className={css.relatedArticle}>
                            <div className={css.relatedRow}>
                                <div className={css.relatedHeading}>
                                    <FormattedMessage id="BlogArticle.relatedArticles" />
                                </div>
                                <NamedLink name='BlogMainPage'>
                                    <FormattedMessage id="BlogArticle.viewAllArticles" />
                                </NamedLink>
                            </div>
                            <div className={css.relatedArticleCards}>
                                {relatedListings?.map(l => (
                                    <BlogCard key={l?.id?.uuid} listing={l} />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className={css.bottomCover}>
                        <div className={css.languageCover}>
                            <div className={css.languageTitle}>
                                <FormattedMessage id="RewardPage.cta.title" defaultMessage="Learn Arabic. Live the Language." />
                            </div>
                            <div className={css.languageText}>
                                <FormattedMessage id="RewardPage.cta.text" defaultMessage="Connect, grow, and earn rewards by learning consistently." />
                            </div>
                            <div className={css.joinButton}>
                                <a href="/s">
                                    <FormattedMessage id="RewardPage.cta.join" defaultMessage="Join Us Today" />
                                </a>
                            </div>
                            <div className={css.flipAnimationLeft}>
                                <svg width="96" height="86" viewBox="0 0 96 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M89.2727 31.9133C82.5239 24.2146 72.9932 19.5121 62.7773 18.8404C52.5613 18.1687 42.497 21.5827 34.7982 28.3315C27.0995 35.0803 22.397 44.611 21.7253 54.8269C21.0535 65.0429 24.4676 75.1072 31.2164 82.806L60.2445 57.3597L89.2727 31.9133Z"
                                        fill="#FEC220" />
                                </svg>
                            </div>
                        </div>
                    </div></>}

            </LayoutSingleColumn>
        </Page>
    );
}

const mapStateToProps = state => {
    const { currentUser } = state.user;
    const { id, showInProgress } = state.BlogArticlePage || {};
    const { currentPageResultIds } = state.BlogMainPage || {};
    const listings = getOwnListingsById(state, currentPageResultIds);
    let currentListing = null;
     const getListing = (id) => {
       const ref = { id, type: 'listing' };
       const listings = getMarketplaceEntities(state, [ref]);
       return listings?.length === 1 ? listings[0] : null;
     };
    if (id) {
        const listings = getListingsById(state, [id]);
        currentListing = listings && listings.length ? listings[0] : null;
    }

    return {
        currentUser,
        listing:currentListing,
        getListing,
        loading: showInProgress,
        listings,
        scrollingDisabled: isScrollingDisabled(state)
    };
};

const mapDispatchToProps = dispatch => ({
    // 
});

const BlogAricle = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(BlogAricleComponent);
export default BlogAricle;